import {createEvent, type Emitter, type Listener} from "react-event-hook";

export interface AnswerCheckedPayload {
    taskType: string;
}

interface Event {
    useAnswerCheckedListener: Listener<AnswerCheckedPayload>;
    emitAnswerChecked: Emitter<AnswerCheckedPayload>;
}

export const {useAnswerCheckedListener, emitAnswerChecked} = createEvent(
    "answer-checked",
)() satisfies Event;
